// @flow

import type { RiskSignals } from '../hooks/use-risk-signals';

const PAYMENT_TYPE_CODE = 'pix-jsr';
const OPERATION_ENROLLMENT = 'hosted_enrollment_register';
const COUNTRY_CODE_BR = 'br';
const IDENTIFICATION_TYPE_CPF = 'cpf';
const FIDO_PLATFORM_BROWSER = 'BROWSER';

type BuildEnrollmentPayloadParams = {|
  +contract: string,
  +cpf: string,
  +bankId: string,
  +riskSignals: RiskSignals,
|};

type EnrollmentPayload = {|
  +contract: string,
  +payment_type_code: string,
  +operation: string,
  +enrollment: {|
    +country: string,
    +notification_url: string,
    +identification_type: string,
    +identification: string,
    +account_details: {|
      +bank_id: string,
    |},
    +fidoOptions: {|
      +platform: string,
      +risk_signals: RiskSignals,
    |},
  |},
|};

export function buildEnrollmentPayload({
  contract,
  cpf,
  bankId,
  riskSignals,
}: BuildEnrollmentPayloadParams): EnrollmentPayload {
  return {
    contract,
    payment_type_code: PAYMENT_TYPE_CODE,
    operation: OPERATION_ENROLLMENT,
    enrollment: {
      country: COUNTRY_CODE_BR,
      notification_url: '',
      identification_type: IDENTIFICATION_TYPE_CPF,
      identification: cpf.replace(/\D/g, ''),
      account_details: {
        bank_id: bankId,
      },
      fidoOptions: {
        platform: FIDO_PLATFORM_BROWSER,
        risk_signals: riskSignals,
      },
    },
  };
}
